/**
 * @returns {boolean}
 **/
export var isSpecified = function isSpecified(val, props) {
  if (props && props.isSpecified) return !!props.isSpecified(val);
  if (typeof val === 'undefined') return false;
  if (val === null) return false;
  return true;
};